// searchProvider.ts - dataProvider for semantic search

import { config } from '../config';

const aiApiUrl = config.aiApiUrl;

// Helper functions for each dataProvider method
const getList = async (resource: string, params: any) => {
  // Copy all filters, remap 'query' to 'q' for backend compatibility
  const filters = { ...(params.filter || {}) };
  /* if ('query' in filters) {
    filters.q = filters.query;
    delete filters.query;
  }*/
  // Default top_k if not provided
  if (!('top_k' in filters)) {
    filters.top_k = params.pagination?.perPage || 10;
  }

  // Get authentication token from localStorage
  const authData = JSON.parse(localStorage.getItem('auth') || '{}');
  
  const response = await fetch(`${aiApiUrl}/search`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authData.token}`,
    },
    body: JSON.stringify(filters),
  });
  const json = await response.json();

  return {
    data: (json.results || []).map((item: any) => ({
      ...item,
      id: item.id, // ensure each item has an id
    })),
    total: json.results?.length || 0,
  };
};

// Required methods for React Admin - not used. Only getList is implemented.
const getOne = async (resource: string, params: any) => ({ data: {} as any });
const getMany = async (resource: string, params: any) => ({ data: [] as any[] });
const getManyReference = async (resource: string, params: any) => ({ data: [] as any[], total: 0 });
const create = async (resource: string, params: any) => ({ data: {} as any });
const update = async (resource: string, params: any) => ({ data: {} as any });
const updateMany = async (resource: string, params: any) => ({ data: [] as any[] });
const deleteOne = async (resource: string, params: any) => ({ data: {} as any });
const deleteMany = async (resource: string, params: any) => ({ data: [] as any[] });

// Main searchProvider function
export const searchProvider = (type: string, resource: string, params: any) => {
  switch (type) {
    case 'getList':
      return getList(resource, params);
    case 'getOne':
      return getOne(resource, params);
    case 'getMany':
      return getMany(resource, params);
    case 'getManyReference':
      return getManyReference(resource, params);
    case 'create':
      return create(resource, params);
    case 'update':
      return update(resource, params);
    case 'updateMany':
      return updateMany(resource, params);
    case 'delete':
      return deleteOne(resource, params);
    case 'deleteMany':
      return deleteMany(resource, params);
    default:
      throw new Error(`Unsupported method: ${type}`);
  }
};